<template>
  <div class="group-room">
    <nav class="navbar navbar-expand-lg navbar-light bg-light nav-header">
      <div
        class="collapse navbar-collapse"
        :class="[child_locations == 1 ? 'col-lg-2 col-md-2 col-sm-2':'col-lg-6 col-md-6 col-sm-6']"
      >
        <a
          class="navbar-brand"
          @click="fn_btn_back(1)"
        >
          <span>
            <i class="im im-angle-left-circle icon-back" />
          </span>
        </a>
      </div>
      <div
        v-for="(ml, index) in meta_location"
        :key="index"
        class="col-lg-8 col-md-8 col-sm-8 con-child"
      >
        <button
          class="btn btn-default btn-maps"
          @click="fn_getchild(ml,true)"
        >
          <icon icon="map-pin" />
          <br>
          {{ ml.title }}
        </button>
      </div>
      <div
        :class="[child_locations == 1 ? 'col-lg-2 col-md-2 col-sm-2':'col-lg-6 col-md-6 col-sm-6']"
      >
        <a
          href="#"
          @click.prevent="fn_closePopup()"
        >
          <span>
            <i class="im im-x-mark-circle icon-close" />
          </span>
        </a>
      </div>
    </nav>
    <loading :loading="loading" />
    <div
      v-if="maps_location.length > 0 && !loading"
      class="col-lg-12 col-md-12 col-sm-12"
    >
      <button
        v-for="(parent,index) in maps_location"
        :key="index"
        type="button"
        class="btn btn-location m-2"
        @click="fn_getchild(parent,false,parent.id)"
      >
        <icon icon="map-pin" />
        <br>
        {{ parent.title }}
      </button>
    </div>
  </div>
</template>


<script>
  import store from "@/store";
  export default {
    name: "Locations",
    data() {
      return {
        modal_select_location: false,
        selected: 0,
        nav_location: [],
        activeIndex: 0,
        child_locations: 0,
        meta_location: [],
        maps_location: [],

      };
    },
    computed: {
      parent_location() {
        return store.getters["location/parent_location"] || [];
      },
      loading() {
        return store.getters["location/loading"];
      },
      closePop() {
        return store.getters["popup/locationPop"];
      },
      auth_user() {
        return store.getters["auth/user"];
      },
      change_locations(){
        return store.getters['location/change_locations'];
      },
      sale_id(){
        return store.getters['location/sale_id'];
      },
      save_change_locations(){
        return store.getters['location/save_change_locations'];
      }
    },
    watch: {
      parent_location: function(val) {
        this.maps_location = _.filter(val, function(el) {
          return el.parent_id === 0;
        });
      }
    },
    mounted() {
      let input = {
        type_id: this.auth_user.type_id,
        type: this.auth_user.type,
        search: "",
        page: "1",
        limit: "12"
      };
      this.fetchParentLocation(input);
    },
    methods: {
      fn_btn_back(isBackBtn, index) {
        if (isBackBtn) {
          let preIndex = this.meta_location.length - 1;
          if (preIndex <= 0) {
            this.meta_location = [];
            this.maps_location = _.filter(this.parent_location, function(el) {
              return el.parent_id === 0;
            });
            this.child_locations = 0;
            return;
          }
          let l = _.find(this.meta_location, function(el) {
            return el.index_id === preIndex;
          });
          let arrLocations = _.remove(this.meta_location, function(o) {
            return o.index_id === l.index_id;
          });
          this.fn_getchild(l);
          this.meta_location = arrLocations;
          this.child_locations = 0;
        }
      },
      async fn_getchild(child, isParent, id) {
        var select_locations_name = "";
        var select_locations_id = "";
        let data = _.filter(this.parent_location, function(el) {
          return el.parent_id === child.id;
        });
        if (!data.length > 0) {
          let select_arr = _.map(this.maps_location, function(el) {
            if (el.id === id) {
              select_locations_name = el.title;
              select_locations_id = el.id;
            }
          });
          let selected_locations = {
            location_name: select_locations_name,
            location_id: select_locations_id
          };
          this.$store.dispatch(
            "location/fetch_selected_locations_name",
            selected_locations
          );
          if(this.change_locations){
            let input = {
              sale_id : this.sale_id,
              location_id : select_locations_id,
            }
            await store.dispatch("location/saveOrderChangeLocation",input);
            let input_arr = {
              id : this.sale_id,
              location_id : select_locations_id,
              location_name : select_locations_name
            }
            this.$store.dispatch("order_list/mutaionUpdateLocationAction",input_arr);
          }
          this.$store.dispatch("popup/updateLocationPopAction", false);
          return;
        }
        this.maps_location = data;
        if (!isParent) {
          this.fn_btn_back(0, false);
          child.index_id = this.meta_location.length + 1;
          this.meta_location.push(child);
        }

        this.meta_location.splice(
          [child.index_id],
          [this.meta_location.length - 1]
        );
        this.child_locations = 1;
      },
      fn_closePopup() {
        this.$store.dispatch("popup/updateLocationPopAction", false);
      },
      fetchParentLocation(input) {
        this.$store.dispatch("location/fetch_parent_location", input);
      },
      close_modal_selection() {
        this.modal_select_location = false;
      }
    }
  };
</script>
<style lang="scss" scoped>
.btn-maps {
  height: 80px;
  min-width: 100px;
  border-color: #fff;
  background: #e0e0e0;
}

.icon-close,
.icon-back {
  font-size: 40px;
  color: #a7b3a7;
  padding-top: 10px;
}
.con-child{
  width: 100%;
}
.icon-close{
  float: right;
}
.icon-back {
  float: left;
}
.location-right {
  display: block;
  margin: auto;
}
.group-room {
  background: #ffff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #a7b3a7;
  border-color: #f0f1f3;
}
.list-group-item {
  border: 1px solid #fff;
  border-bottom: 1px solid rgb(216, 216, 216);
}
.group-user {
  border-right: 2px solid rgb(216, 216, 216);
}
.icone-img {
  padding-right: 10px;
}
.list-group:hover {
  background: #a7b3a7;
}
</style>
